import { I18n } from '@calendly/i18n';
import { PageHeader } from '@calendly/ui/components/page-header';
import { Tabs, Tab } from '@calendly/ui/components/tabs';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useEffect, useRef, useState, forwardRef } from 'react';
import { EmptyState, EMPTY_STATE_TYPES } from 'components/empty_state';
import { Pagination } from 'features/contacts/list/pagination';
import { useNewEmptyStates, CONTENT_PAGES } from 'features/empty_state';
import { useDebounce } from 'hooks/useDebounce';
import { safeScrollIntoView } from 'shared/utils';
import { useFetchContacts } from '../hooks';
import { TableView } from './contacts_table';
import { SearchFilter } from './search_filter';
import { OpenNewContactDrawerButton } from '../shared/open_new_contact_drawer_button';
const containerCss = "c7zcosw";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const controlRowCss = "cqwike4";
const ControlRow = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(controlRowCss, props.className)} />;
});
const leftContentCss = "lh7405e";
const LeftContent = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(leftContentCss, props.className)} />;
});
const mobileNewContactContainerCss = "m1khfq1s";
const MobileNewContactContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(mobileNewContactContainerCss, props.className)} />;
});
export const ContactList = () => {
  const [activeTab, setActiveTab] = useState('all');
  const [pagePath, setPagePath] = useState('');
  const [searchQuery, setSearchQuery] = useState();
  const debouncedQuery = useDebounce(searchQuery, 300);
  const {
    data,
    isLoading,
    isError
  } = useFetchContacts(activeTab, pagePath, debouncedQuery);
  const isMobile = useDeviceType('isPhone');
  const paginationRef = useRef(null);
  const isNewEmptyStateEnabled = useNewEmptyStates();
  const handleScrollToTableHeader = () => {
    // Use safe scrollIntoView utility to prevent iOS Chrome NotFoundError
    safeScrollIntoView(paginationRef.current, {
      behavior: 'smooth',
      block: 'start'
    });
  };
  const showEmptyState = () => isNewEmptyStateEnabled && activeTab === 'all' && !searchQuery && !debouncedQuery && !pagePath && !data?.pagination?.previousPage && data?.contacts?.length === 0 && !isLoading;
  useEffect(() => {
    if (setSearchQuery) setSearchQuery(debouncedQuery);
  }, [setSearchQuery, debouncedQuery]);
  if (showEmptyState()) {
    return <>
        <PageHeader title={I18n.t('publisher.contacts.contacts')} actions={[<OpenNewContactDrawerButton key="new-contact-drawer" decoration={isNewEmptyStateEnabled ? 'primary' : 'bare'} />]} />
        <EmptyState type={EMPTY_STATE_TYPES.leftRight} contentKey={CONTENT_PAGES.contacts} />
      </>;
  }
  return <>
      <PageHeader title={I18n.t('publisher.contacts.contacts')} tabs={<Tabs>
            <Tab onClick={() => setActiveTab('all')} selected={activeTab === 'all'}>
              {I18n.t('publisher.contacts.tabs.all_contacts')}
            </Tab>
            <Tab onClick={() => setActiveTab('favorites')} selected={activeTab === 'favorites'}>
              {I18n.t('publisher.contacts.tabs.favorites')}
            </Tab>
          </Tabs>} actions={[<OpenNewContactDrawerButton key="new-contact-drawer" decoration={isNewEmptyStateEnabled ? 'primary' : 'bare'} />]} />
      <Container ref={paginationRef}>
        {!isMobile && <ControlRow>
            <LeftContent>
              <SearchFilter onSearch={query => setSearchQuery(query)} />
            </LeftContent>
          </ControlRow>}
        {isMobile && <div>
          <MobileNewContactContainer>
            <OpenNewContactDrawerButton mobile />
          </MobileNewContactContainer>
          <SearchFilter onSearch={query => setSearchQuery(query)} />
        </div>}
        <TableView data={data} isLoading={isLoading} isError={isError} />
        <Pagination activeTab={activeTab} setPagePath={setPagePath} data={data} handleScrollToTableHeader={handleScrollToTableHeader} />
      </Container>
    </>;
};

require("./contact_list.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./contact_list.js");